// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._XIMzfAfaAcE7fX_xuYD {
  position: fixed;
  top: 1px;
  height: 30px;
  width: 100%;
  background: var(--ingame-header-background, #1c1c1e);
  border-radius: 10px 10px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  z-index: 1000;
}
._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'],
._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'],
._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] {
  position: relative;
}
._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'],
._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'],
._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] {
  height: 42px;
  top: 0;
}
._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .hg_K8g1ykw3Smh9Jwf6O,
._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .hg_K8g1ykw3Smh9Jwf6O,
._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .hg_K8g1ykw3Smh9Jwf6O {
  font: normal 500 24px var(--font-family-primary);
}
._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .Gmic_XkvuRLcO3qR70fN img,
._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .Gmic_XkvuRLcO3qR70fN img,
._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .Gmic_XkvuRLcO3qR70fN img {
  height: 22px;
  width: 22px;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'],
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'],
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] {
    height: 36px;
  }
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .hg_K8g1ykw3Smh9Jwf6O,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .hg_K8g1ykw3Smh9Jwf6O,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .hg_K8g1ykw3Smh9Jwf6O {
    font-size: 20px;
  }
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .Gmic_XkvuRLcO3qR70fN svg,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .Gmic_XkvuRLcO3qR70fN svg,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .Gmic_XkvuRLcO3qR70fN svg {
    height: 18px;
    width: 18px;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .Gmic_XkvuRLcO3qR70fN svg,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .Gmic_XkvuRLcO3qR70fN svg,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .Gmic_XkvuRLcO3qR70fN svg {
    height: 20px;
    width: 20px;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .Gmic_XkvuRLcO3qR70fN img,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='prize-pop'] .Gmic_XkvuRLcO3qR70fN svg,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='tournaments'] .Gmic_XkvuRLcO3qR70fN svg,
  ._XIMzfAfaAcE7fX_xuYD[data-campaigns='rebate'] .Gmic_XkvuRLcO3qR70fN svg {
    height: 20px;
    width: 20px;
  }
}
}
}
}
.hg_K8g1ykw3Smh9Jwf6O {
  font: normal 400 18px Roboto;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0;
  user-select: none;
  margin: 0;
}
@media (min-width: 769px) {
  .hg_K8g1ykw3Smh9Jwf6O {
    font-size: 24px;
  }
}
.XINXDBgNIWsgCeOyqNOu {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
}
.XINXDBgNIWsgCeOyqNOu img,
.XINXDBgNIWsgCeOyqNOu svg {
  height: 18px;
}
@media (orientation: landscape) {
  .XINXDBgNIWsgCeOyqNOu img,
  .XINXDBgNIWsgCeOyqNOu svg {
    height: 20px;
  }
}
@media (hover: none) and (pointer: coarse) {
  .XINXDBgNIWsgCeOyqNOu:active {
    transform: translateY(-50%) scale(0.95);
  }
}
.Gmic_XkvuRLcO3qR70fN {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 4px;
  padding: 0;
  padding-right: 12px;
  min-width: unset;
  min-height: unset;
}
.Gmic_XkvuRLcO3qR70fN img,
.Gmic_XkvuRLcO3qR70fN svg {
  height: 18px;
  width: 18px;
}
@media (orientation: landscape) {
  .Gmic_XkvuRLcO3qR70fN img,
  .Gmic_XkvuRLcO3qR70fN svg {
    height: 20px;
    width: 20px;
  }
}
@media (hover: none) and (pointer: coarse) {
  .Gmic_XkvuRLcO3qR70fN:active {
    transform: translateY(-50%) scale(0.95);
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/InGameHeader/InGameHeader.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,oDAAoD;EACpD,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;AACf;AACA;;;EAGE,kBAAkB;AACpB;AACA;;;EAGE,YAAY;EACZ,MAAM;AACR;AACA;;;EAGE,gDAAgD;AAClD;AACA;;;EAGE,YAAY;EACZ,WAAW;AACb;AACA;EACE;;;IAGE,YAAY;EACd;EACA;;;IAGE,eAAe;EACjB;EACA;;;;;;IAME,YAAY;IACZ,WAAW;EACb;AACF;AACA;AAAA;EACE;;;;;;IAME,YAAY;IACZ,WAAW;EACb;AACF;AAAA;AAVA;AAAA;AAAA;AAAA;EACE;;;;;;IAME,YAAY;IACZ,WAAW;EACb;AACF;AAAA;AAAA;AAAA;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,YAAY;AACd;AACA;EACE;;IAEE,YAAY;EACd;AACF;AACA;EACE;IACE,uCAAuC;EACzC;AACF;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;EAEE,YAAY;EACZ,WAAW;AACb;AACA;EACE;;IAEE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,uCAAuC;EACzC;AACF","sourcesContent":[".header {\n  position: fixed;\n  top: 1px;\n  height: 30px;\n  width: 100%;\n  background: var(--ingame-header-background, #1c1c1e);\n  border-radius: 10px 10px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  z-index: 1000;\n}\n.header[data-campaigns='tournaments'],\n.header[data-campaigns='prize-pop'],\n.header[data-campaigns='rebate'] {\n  position: relative;\n}\n.header[data-campaigns='prize-pop'],\n.header[data-campaigns='tournaments'],\n.header[data-campaigns='rebate'] {\n  height: 42px;\n  top: 0;\n}\n.header[data-campaigns='prize-pop'] .title,\n.header[data-campaigns='tournaments'] .title,\n.header[data-campaigns='rebate'] .title {\n  font: normal 500 24px var(--font-family-primary);\n}\n.header[data-campaigns='prize-pop'] .closeButton img,\n.header[data-campaigns='tournaments'] .closeButton img,\n.header[data-campaigns='rebate'] .closeButton img {\n  height: 22px;\n  width: 22px;\n}\n@media (--campaign-mobile) {\n  .header[data-campaigns='prize-pop'],\n  .header[data-campaigns='tournaments'],\n  .header[data-campaigns='rebate'] {\n    height: 36px;\n  }\n  .header[data-campaigns='prize-pop'] .title,\n  .header[data-campaigns='tournaments'] .title,\n  .header[data-campaigns='rebate'] .title {\n    font-size: 20px;\n  }\n  .header[data-campaigns='prize-pop'] .closeButton img,\n  .header[data-campaigns='tournaments'] .closeButton img,\n  .header[data-campaigns='rebate'] .closeButton img,\n  .header[data-campaigns='prize-pop'] .closeButton svg,\n  .header[data-campaigns='tournaments'] .closeButton svg,\n  .header[data-campaigns='rebate'] .closeButton svg {\n    height: 18px;\n    width: 18px;\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .header[data-campaigns='prize-pop'] .closeButton img,\n  .header[data-campaigns='tournaments'] .closeButton img,\n  .header[data-campaigns='rebate'] .closeButton img,\n  .header[data-campaigns='prize-pop'] .closeButton svg,\n  .header[data-campaigns='tournaments'] .closeButton svg,\n  .header[data-campaigns='rebate'] .closeButton svg {\n    height: 20px;\n    width: 20px;\n  }\n}\n.title {\n  font: normal 400 18px Roboto;\n  color: #ffffff;\n  text-transform: uppercase;\n  letter-spacing: 0;\n  user-select: none;\n  margin: 0;\n}\n@media (min-width: 769px) {\n  .title {\n    font-size: 24px;\n  }\n}\n.searchButton {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.searchButton img,\n.searchButton svg {\n  height: 18px;\n}\n@media (orientation: landscape) {\n  .searchButton img,\n  .searchButton svg {\n    height: 20px;\n  }\n}\n@media (hover: none) and (pointer: coarse) {\n  .searchButton:active {\n    transform: translateY(-50%) scale(0.95);\n  }\n}\n.closeButton {\n  position: absolute;\n  top: 50%;\n  right: 0px;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n  border-radius: 4px;\n  padding: 0;\n  padding-right: 12px;\n  min-width: unset;\n  min-height: unset;\n}\n.closeButton img,\n.closeButton svg {\n  height: 18px;\n  width: 18px;\n}\n@media (orientation: landscape) {\n  .closeButton img,\n  .closeButton svg {\n    height: 20px;\n    width: 20px;\n  }\n}\n@media (hover: none) and (pointer: coarse) {\n  .closeButton:active {\n    transform: translateY(-50%) scale(0.95);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `_XIMzfAfaAcE7fX_xuYD`,
	"title": `hg_K8g1ykw3Smh9Jwf6O`,
	"closeButton": `Gmic_XkvuRLcO3qR70fN`,
	"searchButton": `XINXDBgNIWsgCeOyqNOu`
};
export default ___CSS_LOADER_EXPORT___;
